import { Component, Injector, Input, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { TokenPopUpViewComponent } from '../token-pop-up-view/token-pop-up-view.component';

@Component({
  selector: 'app-single-view-token',
  templateUrl: './single-view-token.component.html',
  styleUrls: ['./single-view-token.component.scss'],
  standalone: false
})
export class SingleViewTokenComponent implements OnInit, OnDestroy {
  screen_data: any = null;
  desk: any[] = []; totalnoOfDesk = 0;
  screen: any[] = []; activeblink = { desk: 0, token: 0 }
  Interval: any = null; autoRefreshInterval: any = null;
  refreshTime: number = 2000; nextTokenArray: any[] = [1, 2, 3, 4, 5];
  MultipleTokenShow = false; counter_per_screen: any = 9
  currentScreenIndex = 0; title_image_id: string = "";
  scrollSpeed = 1; css: any = { "header-color": "#c6bb9a", "body-color": "#dcd3bc", "font-color": "black", "room-font-color": "#000000" };
  deskPerScreen: any // assing Index
  bg_profile_path = "/dms/api/v1/orgImage/image-response-entity?args=id:";
  animationFrameId: number;
  roomConfig: boolean = true;
  _dataCss: any = null;
  @ViewChild('scrollContainer', { static: true })
  scrollContainer!: ElementRef<HTMLDivElement>;

  constructor(
    public baseService: BaseService,
    public router: Router,
    public injector: Injector,
    public route: ActivatedRoute,
    public alert: AlertsService,
    public communicationService: CommunicationService,
    private auth: AuthenticationService,
    private smartModalService: SmartModalService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    const routePath = this.route?.snapshot?.routeConfig?.path || '';
    if (routePath.includes('multiple')) this.MultipleTokenShow = true;
    if (this.MultipleTokenShow) this.checkConfigForRoomWise();
    this.communicationService.emitTokenNotification$.subscribe((res: any) => {
      if (res) {
        this.activeblink.desk = res.notification.body && res.notification.body.split("desk_name-").length ? res.notification.body.split("desk_name-")[1] : 0;
        this.activeblink.token = res.notification.body && res.notification.body.split(",")[0] && res.notification.body.split(",")[0].split("token-") && res.notification.body.split(",")[0].split("token-")[1] ? res.notification.body.split(",")[0].split("token-")[1] : 0;
        this.openPopUp(this.activeblink);
      }
    })


    const key = this.route?.snapshot?.queryParams?.key;
    if (!key) return;
    // console.log('Screen Key:', key,"");
    this.getDeskName$(key)?.subscribe((res: any) => {
      const screenNumber = res?.resource?.[0]?.screen_number;
      //this.deskPerScreen = res?.resource?.[0]?.counter_per_screen ? res?.resource?.[0]?.counter_per_screen : 9;
      this.counter_per_screen = res?.resource?.[0]?.counter_per_screen ? res?.resource?.[0]?.counter_per_screen : 9;
      if (!screenNumber) return;
      this.getScreenRefreshRate$(screenNumber)?.subscribe((data: any) => {
        this.screen_data = data?.resource?.[0] || {};
        this.title_image_id = data.resource && data.resource[0] && data.resource[0].bg_title_image_id ? this.bg_profile_path + data.resource[0].bg_title_image_id : "";
        this.refreshTime = (this.screen_data?.refresh_rate * 1000) || 2000;
        if (this.css && this.screen_data.header_color_code) {
          this.css['header-color'] = this.screen_data.header_color_code;
        }
        if (this.css && this.screen_data.grid_color_code) {
          this.css['body-color'] = this.screen_data.grid_color_code;
        }
        if (this.css && this.screen_data.font_color_code) {
          this.css['font-color'] = this.screen_data.font_color_code;
        }
        if (this.css && this.screen_data.room_font_color) {
          this.css['room-font-color'] = this.screen_data.room_font_color;
        }
        const patientPerQueue = this.MultipleTokenShow ? 6 : this.screen_data?.patient_per_queue;
        if (this.screen_data?.patient_per_queue) {
          this.nextTokenArray = Array.from({ length: this.screen_data?.patient_per_queue - 1 }, (v, k) => k + 1);
        }
        this._dataCss = data.resource[0] && data.resource[0].css ? data.resource[0].css : '';
        if (this._dataCss) {
          const style = this.renderer.createElement('style');
          style.textContent = this._dataCss;
          this.renderer.appendChild(document.head, style);
        }
        this.getData(screenNumber, patientPerQueue);
        this.startAutoRefresh();
      });
    });
  }

  getScreenRefreshRate$(screen_number: any) {
    if (!screen_number) return;
    return this.baseService.get('GET_PAGE', '', 'screen_master', 'facility-management', 'screen_number:' + screen_number);
  }

  // playRing() {
  //   let audio: any = document.getElementById("play_ringtone");
  //   if (audio) {
  //       try {
  //           audio.muted = false;
  //           audio.load();
  //           audio.play()
  //               .then(() => {
  //                   this.muted = true;
  //                   console.log("Audio played successfully.");
  //               })
  //               .catch((error: any) => {
  //                   console.error("Audio play failed:", error);
  //               });
  //       } catch (error) {
  //           console.error("Error occurred while playing audio:", error);
  //       }
  //   } else {
  //       console.error("Audio element with ID 'play_ringtone' not found.");
  //   }
  // }

  getData(key: any, token_limit: any): void {
    if (!key) return;
    this.getDataApi$(key, token_limit)?.subscribe((res: any) => {
      this.desk = res?.resource || [];
      this.deskPerScreen = 9;//this.desk.length >= 9 ? this.desk.length: 9;
      const sortedDesks = [...res.resource.filter(x => x.queueDeskMapping?.length).sort((a, b) => a.desk_name.localeCompare(b.desk_name)), ...res.resource.filter(x => !x.queueDeskMapping?.length).sort((a, b) => a.desk_name.localeCompare(b.desk_name))];
      this.desk = sortedDesks
      this.checkSidebarOpen();
      if (this.totalnoOfDesk != res.resource.length) {
        this.screenActivitylog(key);
        this.totalnoOfDesk = res.resource.length;
      }
      this.screen = [];
      for (let i = 0; i < Math.ceil(this.desk.length / this.counter_per_screen); i++) {
        this.screen.push(this.desk.slice(i * this.counter_per_screen, (i + 1) * this.counter_per_screen).filter(x => x));
      }
      // this.sixDeskoneScreen();
      if (this.desk.length > 9) { // desk length is greater than 9 then only we need to auto scroll otherwise no need to auto scroll
        this.startAutoScroll()
      }

    });
    console.log('Screen Data:', this.screen, this.desk);
  }

  getDataApi$(key: any, token_limit: any) {
    if (!key) return;
    return this.baseService.get('GET_BY_NEW_SCREEN', `screen_number:${key},token_limit:${this.MultipleTokenShow ? 6 : this.screen_data?.patient_per_queue}`, 'queue_desk', 'queue-management');
  }

  getDeskName$(key: any) {
    if (!key) return;
    return this.baseService.get('GET_BY_ID', `id:${key}`, 'screen_master', 'facility-management');
  }

  checkConfigForRoomWise() {
    this.baseService.get('GET_CONFIG', 'config_code:qms_room_enable,module_code:queue-management', 'facility_config_mapping', 'facility-management').subscribe((res: any) => {
      const value = res?.resource?.[0]?.config_value;
      this.roomConfig = value === true || value === 'true';
    });
  }

  screenActivitylog(screen_no: any): void {
    let _obj = {
      "screen_no": screen_no,
      "user_id": this.auth.getCurrentUser().user_id
    }
    this.baseService.action(_obj, "ADD", "queue-management", 'screen_activity_log').subscribe((res: any) => {
    })
  }

  openPopUp(token: any) {
    token['generateToken'] = false;
    this.smartModalService.open(TokenPopUpViewComponent, token, "", ModalSize.Md, "hide", "token-alert-popup").subscribe((result: any) => { });
  }

  startAutoRefresh(): void {
    this.autoRefreshIntervalFn();
    if (!this.refreshTime || !this.screen_data?.screen_number) return;
    this.autoRefreshInterval = setInterval(() => {
      this.getData(this.screen_data?.screen_number, this.screen_data?.patient_per_queue);
      if (this.screen?.length > 0) {
        this.currentScreenIndex = (this.currentScreenIndex + 1) % this.screen.length;
      }
    }, this.refreshTime);
  }

  autoRefreshIntervalFn(): void {
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
      this.autoRefreshInterval = null;
    }
  }

  ngOnDestroy(): void {
    this.autoRefreshIntervalFn();
    this.checkSidebarOpen(true);
    this.stopAutoScroll();
  }

  // calculateStyles(_hasLength: any, deskSize?):any {
  //     return {  height: calc(90vh / 9); }
  // }

  checkSidebarOpen(destroy = false): void {
    const header = document.getElementsByTagName('app-header')?.[0] as HTMLElement;
    if (!header) return;
    let hideHeader = document.getElementById("core-body");
    if (!destroy) {
      this.communicationService.emitSidebar({ sidebar: false });
      header.style.display = 'none';
      if (hideHeader) {
        const style = document.createElement('style');
        style.textContent = `.header-fixed .app-body {  margin-top: 0px !important;    overflow-x: hidden !important;}`;
        document.head.appendChild(style);
      }
    } else {
      header.style.display = 'block';
      this.communicationService.emitSidebar({ sidebar: true });
      if (hideHeader) {
        const style = document.createElement('style');
        style.textContent = `.header-fixed .app-body {  margin-top: 55px !important;    overflow-x: hidden !important;}`;
        document.head.appendChild(style);

      }
    }
  }

  sixDeskoneScreen(): void {
    if (this.screen?.[this.currentScreenIndex]?.length && this.screen[this.currentScreenIndex].length !== this.counter_per_screen) {
      this.screen[this.currentScreenIndex].length = this.counter_per_screen;
    }
  }

  getCorrectMapping(queueDeskMapping: any[]): any {
    if (queueDeskMapping.length) {
      queueDeskMapping = queueDeskMapping.filter(x => x.stage != "Serving")
    }
    let length = queueDeskMapping?.length || 0;
    return [...queueDeskMapping, ...Array.from({ length: this.nextTokenArray.length - length }, (value, index) => index).map(x => { return {} })];
  }

  getRoomName(r: any) {
    return r && r.queueDeskMapping && r.queueDeskMapping.length && r.queueDeskMapping[0].room_name ? r.queueDeskMapping[0].room_name : "";
  }

  getHeightOfHeader() {
    let value = <any>document.getElementsByClassName("cstm-header-v1")[0];
    return value ? value.offsetHeight + 'px' : '';
  }

  startAutoScroll() {
    this.stopAutoScroll();
    const container = this.scrollContainer?.nativeElement;
    if (!container) return;
    container.style.overflowY = 'auto';
    container.style.height = this.getHeightOfHeader() ? 'calc(100vh - 10vh - ' + this.getHeightOfHeader() + ')' : '90vh';
    container.style.display = 'block';
    let lastTime = 0;
    const delay = 40;
    const speed = 0.5; // Adjust scroll speed as needed
    const scroll = (time: number) => {
      if (!lastTime) lastTime = time;
      const delta = time - lastTime;
      if (delta >= delay) {
        const maxScroll = container.scrollHeight - container.clientHeight;
        if (maxScroll > 0) {
          container.scrollTop += speed;
          if (container.scrollTop >= maxScroll) {
            container.scrollTop = 0;
          }
        }
        lastTime = time;
      }
      this.animationFrameId = requestAnimationFrame(scroll);
    };
    setTimeout(() => {
      this.animationFrameId = requestAnimationFrame(scroll);
    }, 500);
  }

  private stopAutoScroll() {
    if (this.animationFrameId !== null) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

}
